import { render, staticRenderFns } from "./ScheduleCard.vue?vue&type=template&id=283ffee5&scoped=true"
import script from "./ScheduleCard.vue?vue&type=script&lang=js"
export * from "./ScheduleCard.vue?vue&type=script&lang=js"
import style0 from "./ScheduleCard.vue?vue&type=style&index=0&id=283ffee5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283ffee5",
  null
  
)

export default component.exports